(function() {
'use strict';

    angular
        .module('iMatApp')
        .factory('uiService', uiService);

    uiService.inject = [];
    function uiService() {
        var service = {
            scrollToTop: scrollToTop
        };
        
        return service;

        // ---------------------------------------------
        function scrollToTop(speed) {
            speed = speed || 1000;

            angular.element('html, body').animate({
                scrollTop: 0
            }, speed);
        }
    }
})();